import PropTypes from 'prop-types';
import React, { createContext } from 'react';

export const SessionContext = createContext();

export const SessionContextProvider = (props) => (
  <SessionContext.Provider value={{}}>{props.children}</SessionContext.Provider>
);

SessionContextProvider.propTypes = {
  children: PropTypes.node,
};
